var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDadosEmpresa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-building",
    "data-name": "Icon awesome-building",
    d: "M14.6,14.063h-.67V.7a.758.758,0,0,0-.8-.7H1.875a.758.758,0,0,0-.8.7v13.36H.4a.379.379,0,0,0-.4.352V15H15v-.586A.379.379,0,0,0,14.6,14.063ZM4.286,2.227a.379.379,0,0,1,.4-.352H6.027a.379.379,0,0,1,.4.352V3.4a.379.379,0,0,1-.4.352H4.688a.379.379,0,0,1-.4-.352Zm0,2.813a.379.379,0,0,1,.4-.352H6.027a.379.379,0,0,1,.4.352V6.211a.379.379,0,0,1-.4.352H4.688a.379.379,0,0,1-.4-.352ZM6.027,9.375H4.688a.379.379,0,0,1-.4-.352V7.852a.379.379,0,0,1,.4-.352H6.027a.379.379,0,0,1,.4.352V9.024A.379.379,0,0,1,6.027,9.375Zm2.545,4.688H6.429V11.6a.379.379,0,0,1,.4-.352H8.17a.379.379,0,0,1,.4.352Zm2.143-5.039a.379.379,0,0,1-.4.352H8.973a.379.379,0,0,1-.4-.352V7.852a.379.379,0,0,1,.4-.352h1.339a.379.379,0,0,1,.4.352Zm0-2.813a.379.379,0,0,1-.4.352H8.973a.379.379,0,0,1-.4-.352V5.039a.379.379,0,0,1,.4-.352h1.339a.379.379,0,0,1,.4.352Zm0-2.813a.379.379,0,0,1-.4.352H8.973a.379.379,0,0,1-.4-.352V2.227a.379.379,0,0,1,.4-.352h1.339a.379.379,0,0,1,.4.352Z",
    fill: "#64c2c8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDadosEmpresa);
export default __webpack_public_path__ + "static/media/dadosEmpresa.d85d562df39f6c1c90f6dbf218bc190d.svg";
export { ForwardRef as ReactComponent };